/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-18 21:37:09
 * @LastEditTime: 2019-07-24 14:40:36
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  根据用户ID查询认证信息
const getAuthInfoUrl = '/authentication/cmsAuthenticationAppeal/getUserById'

//  添加认证申诉
const createInfoUrl = '/authentication/cmsAuthenticationAppeal/add'

//  修改认证申诉信息
const updateInfoUrl = '/authentication/cmsAuthenticationAppeal/update'

//  根据companyName查询信息
const getByCompanyNameUrl = '/authentication/cmsAuthenticationAppeal/getByCompanyName'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 撤销资质申诉
export function nolleProsequi(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAuthInfoUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'nolleProsequi'
      }, param))
    }
  })
}

// 根据用户ID查询认证信息
export function getAuthInfo(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAuthInfoUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getUserById'
      }, param))
    }
  })
}

//  添加资格认证列表
export function createInfo(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + createInfoUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'saveCmsAuthenticationAppeal'
      }, param))
    }
  })
}

// 修改资格认证信息
export function editInfo(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + updateInfoUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'updateCmsAuthenticationAppeal'
      }, param))
    }
  })
}

// 修改资格认证信息
export function getByCompanyName(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getByCompanyNameUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findByCompanyName'
      }, param))
    }
  })
}
